import type { TChatRoom, IChatRoomFilter } from "./types";
import {
  getPaginatedFilteredPathParam,
  getPathParam,
  createPathParam,
  type NoPathParams,
} from "@/api/shared/crud";

export * from "./types";

const SLUG = "message/room";

export const RoomService = {
  getAllRoomsPaginatedFiltered: getPaginatedFilteredPathParam<
    TChatRoom,
    NoPathParams,
    IChatRoomFilter
  >(SLUG),

  getChatRoom: getPathParam<TChatRoom, { id: string }>(`${SLUG}/{id}`),

  addChatRoomMembers: createPathParam<TChatRoom, { id: string }, { staff_members: string[] }>(
    `${SLUG}/{id}/add-members`
  ),

  leaveChatRoom: createPathParam<void, { id: string }, void>(`${SLUG}/{id}/leave`),

  muteChatRoom: createPathParam<void, { id: string }, void>(`${SLUG}/{id}/mute`),

  unmuteChatRoom: createPathParam<void, { id: string }, void>(`${SLUG}/{id}/unmute`),

  createDirectChatRoom: createPathParam<TChatRoom, NoPathParams, { staff_recipient: string }>(
    `${SLUG}/direct`
  ),

  createGroupChatRoom: createPathParam<TChatRoom, NoPathParams, { staff_members: string[] }>(
    `${SLUG}/group`
  ),
} as const;
